<script setup lang="ts">
import { BuildingStorefrontIcon } from '@heroicons/vue/24/outline';
import { Avatar } from '@app/panel/Components';
import * as Types from '@app/panel/types/generated';

type NoteViewModel = Types.App.Models.ViewModels.NoteViewModel;

defineProps<{
  user: NoteViewModel['user'];
  customer: NoteViewModel['customer'];
}>();
</script>

<template>
  <div class="shrink-0">
    <Avatar
      v-if="user || customer"
      rounded
      :src="user?.profilePhotoUrl ?? 'https://ui-avatars.com/api/?name=' + customer?.name.substring(0, 2)"
    />
    <div
      v-else
      class="bg-slate-200 size-8 rounded-full grid place-items-center"
    >
      <BuildingStorefrontIcon class="size-5 text-slate-600" />
    </div>
  </div>
</template>
